import React, { useState } from "react";
import {
  Box,
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Select,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
export interface DropDownMenuProps {
  items: { label: string; id: number }[];
  btnTxt: string;
  setSelectedItem: React.Dispatch<React.SetStateAction<any>>;
  value?: string;
}

export function DropDownMenu({
  items,
  btnTxt,
  setSelectedItem,
  value,
}: DropDownMenuProps) {
  const [menuValue, setMenuValue] = useState<string>();

  function getLabel(number: number | undefined | string) {
    if (number ) return items.find(({ id }) => id === +number)?.label;
  }

  return (
    <Menu>
      <MenuButton
      // as={Button}
      // rightIcon={<ChevronDownIcon />}
      // css={{ borderRadius: "0.75rem", border: "none" }}
      >
        <Box position="relative">
          {(getLabel(value) || menuValue) ?? btnTxt}
          <ChevronDownIcon position="absolute" left={1} top={1} />
        </Box>
      </MenuButton>

      <MenuList>
        <MenuOptionGroup
          {...(value ? { value } : {})}
          onChange={(event) => {
            if (typeof event === "string") {
              let selectedLabel = getLabel(+event);

              setMenuValue(selectedLabel);
            }

            setSelectedItem(event);
          }}
          type="radio"
        >
          {items.map(({ id, label }) => (
            <MenuItemOption key={id} value={"" + id}>
              {label}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
}
